import Enhancer from '../enhancer.js';
import EnhancerApp from '../enhancer-app.js';

export default class LoadMoreButtonEnhancer extends Enhancer {
    constructor(element) {
        super(element);
    }

    url = '';
    currentPage = 1;
    target = undefined;

    init() {
        // Get data variables
        this.url = this.element.dataset.loadmoreUrl.startsWith('http')
            ? this.element.dataset.loadmoreUrl
            : location.origin + '/' + this.element.dataset.loadmoreUrl;
        this.currentPage = parseInt(this.element.dataset.loadmoreCurrentpage);
        this.target = document.querySelector(
            '#' + this.element.dataset.loadmoreTarget
        );

        console.log(this.element.dataset.loadmoreUrl);

        // Bind click
        this.element.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(e) {
        e.preventDefault();

        // Set the correct page parameter
        const url = new URL(this.url, document.baseURI);
        const params = new URLSearchParams(url.search);

        params.set('page', this.currentPage + 1);

        url.search = params;

        // Store how many items there were before update
        const elementsCountBeforeUpdate = this.listElements.length;

        // Perform the ajax GET request
        fetch(url.toString()).then((response) => {
            // Increase the current page number
            this.currentPage++;
            window.history.pushState(
                '{Page: ' + this.currentPage + '}',
                document.title,
                '?' + params.toString()
            );

            // Add the result to the target
            response.text().then((text) => {
                // Update list of elements
                this.target.innerHTML = this.target.innerHTML + text;

                const elementsCountAfterUpdate = this.listElements.length;

                // Set focus to first new element
                if (elementsCountAfterUpdate > elementsCountBeforeUpdate) {
                    const elementToFocus = this.listElements[
                        elementsCountBeforeUpdate
                    ];
                    elementToFocus.focus();
                }

                // Reset progress button (change from progress state to default state)
                const progressButtonEnhancer = this.application.getEnhancerForElement(
                    this.element,
                    'ProgressButton'
                );
                progressButtonEnhancer.reset();

                this.pageCountText.innerText =
                    this.pageCount * this.currentPage;
            });

            // Check header that indicates if there are more items
            if (response.headers.get('AAF-HasMore') !== 'true') {
                this.element.style.display = 'none';
            }
        });
    }

    get listElements() {
        return this.target.querySelectorAll(
            this.element.dataset.loadmoreElementsSelector
        );
    }

    get pageCountText() {
        return this.element.querySelector('#page-count');
    }

    get pageCount() {
        return this.element.dataset.hitPerPage;
    }

    set pageCount(value) {
        document.querySelector('#page-count').innerText = value;
    }

    get hasResultText() {
        return this.element.dataset.loadmoreResultText !== undefined;
    }

    set resultText(value) {
        document.querySelector(
            '#' + this.element.dataset.loadmoreResultText
        ).innerText = value;
    }
}

// Enhancers must be registered with a name that is used in the data-enhancer attribute
EnhancerApp.register('LoadMoreButton', LoadMoreButtonEnhancer);
